import React from 'react';
import classNames from 'classnames';
import uniqBy from 'lodash/fp/uniqBy';

import { TranslatedMessage } from 'common/components/Intl';
import Modal from 'common/components/modals/Modal';

/**
 * This component allows for displaying various pods flavors and their
 * respective descriptions in a modal.
 *
 * @public
 * @param {Object[]} pods
 */
const FlavorGuideModal = ({ pods, isOpen, onRequestClose }) => {
  const podFlavorListingItem = (podFlavor, index) => (
    <li
      key={`pod-flavor-listing-item-${podFlavor.id}`}
      className="flavor-guide-modal__pod-flavor-listing-item"
    >
      <div className="flavor-guide-modal__pod-flavor-listing-item-media">
        <img
          className="flavor-guide-modal__pod-flavor-listing-item-image"
          aria-labelledby={`${podFlavor.id}-${index}`}
          src={podFlavor.image_url}
        />
      </div>
      <div className="flavor-guide-modal__pod-flavor-listing-item-copy">
        <div
          className="flavor-guide-modal__pod-flavor-listing-item-label natural-heading--small"
          id={`${podFlavor.id}-${index}`}
        >
          {podFlavor.name}
        </div>
        <div className="flavor-guide-modal__pod-flavor-listing-item-description text--body--small">
          <TranslatedMessage id={podFlavor.descriptionKey} />
        </div>
      </div>
    </li>
  );

  const podFlavors = () => {
    return uniqBy('name', pods).map((pod, index) => {
      const key = pod.name.toLowerCase().replace(/\s/, '-');
      pod.descriptionKey = `eliquids.flavor_descriptions.${key}`;

      return podFlavorListingItem(pod, index);
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className={classNames('flavor-guide-modal')}
      aria={{ modal: 'true', labelledby: 'flavor-guide-label' }}
    >
      <div className="flavor-guide-modal__content">
        <div
          className="flavor-guide-modal__header subheading"
          id="flavor-guide-label"
        >
          <TranslatedMessage id="flavor_guide.label" />
        </div>
        <div className="flavor-guide-modal__body">
          <ul className="flavor-guide-modal__pod-flavor-listing">
            {podFlavors()}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default FlavorGuideModal;
